import _get from 'lodash/get';
import _set from 'lodash/set';
import _merge from 'lodash/merge';
import { Log } from 'mlb-media-player';
import { get as cookiesGet } from 'bam-cookies/dist/browser_browser_es5/main';
import pageMeta from 'pageMeta/pageMeta';
import {
    getMetadataURL,
} from '../utils/forge-utils';


/**
 *
 * @desc MediaItem
 *
 */
class AbstractMediaItem {

    constructor(data, mediaConfig, requestParams) {

        this.data = data;
        this.metaDataJson = undefined;
        this.requestParams = requestParams;
        this.mediaConfig = mediaConfig;
        this.locale = undefined;
        this.title = undefined;
        this.contentId = undefined;
        this.description = undefined;
        this.duration = undefined;
        this.tags = undefined;
        this.src = undefined;
        this.image = undefined;
        this.poster = undefined;
        this.date = undefined;
        this.isLive = undefined;

        /**
         *
         * @desc If true will load the next item when there is a playlist.
         * If `metaDataJson` is set, no fetch will be made.
         * @type boolean
         * @default true
         *
         */
        this.prefetchNextItem = true;

        /**
         *
         * @desc Array of VTT items. A VTT item is an object with the following properties:
         * label {string} e.g. 'English'
         * src {string} URL to the remote VTT resource
         * srclang {string} e.g 'en'
         * default {boolean} If true will be used as the default captions resource
         * @type {array}
         *
         */
        this.vttItems = undefined;


    }

    parseData(data) {

        throw new Error('Implement parseData(data)');

    }

    /**
     *
     * @desc Get the playback scenario.
     * @param {array} playbacks     List of playback scenarios
     * @param {boolean} isLive      Specify if live or vod
     * @param {object} mediaConfig  The apps mediaConfig
     * @returns {object} the playback scenario or an empty object
     */
    getPlaybackScenario(playbacks, isLive) {

        throw new Error('Implement getPlaybackScenario(playbacks, isLive)');

    }

    getImage(cuts, width) {

        throw new Error('Implement getImage(cuts, width)');

    }

    getPoster(cuts, widthSizes) {

        throw new Error('Implement getPoster(cuts, widthSizes)');

    }

    /**
     *
     * Responsible for building the request URL, making, and handling
     * the request for the metadata. This function should call `parseData` with the JSON data response & and handle any request
     * errors.
     *
     */
    getMetaData() {

        throw new Error('Implement getMetaData()');

    }

    /**
     *
     * @desc Creates the adConfig object using the clip data and attaches to the clip.
     * e.g. `cust_params` with `vid` and `aam_uuid` properties
     * @return {object} clip with adConfig
     *
     */
    getAdConfig(data) {

        throw new Error('Implement getAdConfig(data)');

    }


}

export default AbstractMediaItem;
